import { apiClient } from "./client";

export const projectsApi = {
  getAll: () => apiClient.get("/api/projects"),
  getBySlug: (slug) => apiClient.get(`/api/projects/${slug}`),
};
